import { createAuthClient } from 'better-auth/react';
import { anonymousClient } from 'better-auth/client/plugins';

// Le serveur sert le jeu et l'API sur la même origine : aucune baseURL à déclarer, donc ni CORS
// ni cookie tiers — ce dernier point compte, les navigateurs les bloquant de plus en plus.
export const authClient = createAuthClient({
  plugins: [anonymousClient()],
});
